.header {
  font-size: 24px;
  line-height: 30px;
  height: 75px;
  padding-top: 30px;
  box-sizing: border-box;
  font-weight: bold;
  width: 500px;
}
